"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLEAR = exports.SET_FILTER_OPTIONS = exports.SET_ORDER_BY_OPTIONS = exports.FETCH_LINKED_FAILURE = exports.FETCH_LINKED_SUCCESS = exports.FETCH_LINKED_REQUEST = void 0;
const prefix = '@sok/vektorio/linkedFolders/';
exports.FETCH_LINKED_REQUEST = `${prefix}FETCH_LINKED_REQUEST`;
exports.FETCH_LINKED_SUCCESS = `${prefix}FETCH_LINKED_SUCCESS`;
exports.FETCH_LINKED_FAILURE = `${prefix}FETCH_LINKED_FAILURE`;
exports.SET_ORDER_BY_OPTIONS = `${prefix}/SET_ORDER_BY_OPTIONS`;
exports.SET_FILTER_OPTIONS = `${prefix}/SET_FILTER_OPTIONS`;
exports.CLEAR = `${prefix}CLEAR`;
//# sourceMappingURL=linkedFolders.js.map